<script setup>
import MyComplaints from '@/views/complaints/myComplaints.vue'
import { ref } from 'vue'

const tabs = {
  my: 'Мои обращения',
  group: 'Назначенные обращения',
}
const tabsAvail = ['my', 'group']

const tab = ref('my')
</script>

<template>
  <div class="nav nav-tabs">
    <div class="nav-item" v-for="tTitle of tabsAvail" :key="tTitle">
      <a href="#" class="nav-link" :class="{ active: tab == tTitle }" @click.prevent="tab = tTitle">
        {{ tabs[tTitle] }}
      </a>
    </div>
  </div>

  <div class="workspace-inner">
    <MyComplaints filter="my" v-if="tab == 'my'" />
    <MyComplaints filter="group" v-if="tab == 'group'" />
  </div>
</template>
